import React, { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Reusable admin login form. Renders the centred card + password field.
 * Calls `onSubmit(password)` which should return a Promise<boolean>.
 */
export default function AdminGate({ title = "Area riservata", subtitle, onSubmit, error, busy }) {
  const [pw, setPw] = useState("");
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--np-tertiary)" }}>
      <div data-testid="admin-gate" className="w-full max-w-md bg-white rounded-3xl shadow-[0_30px_80px_-30px_rgba(26,42,58,0.35)] overflow-hidden">
        <div className="h-2 bg-tension" />
        <div className="p-8 md:p-10">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6" style={{ background: "var(--np-quaternary)" }}>
            <Lock size={26} style={{ color: "var(--np-secondary)" }} />
          </div>
          <h1 className="text-2xl md:text-3xl tracking-tight" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>{title}</h1>
          {subtitle && <p className="mt-2 text-sm" style={{ color: "var(--np-muted)" }}>{subtitle}</p>}

          <form onSubmit={(e) => { e.preventDefault(); onSubmit(pw.trim()); }} className="mt-7 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="pw" className="text-[12px] font-semibold tracking-wide uppercase" style={{ color: "var(--np-primary)" }}>Password</Label>
              <Input id="pw" data-testid="admin-password-input" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                placeholder="••••••••" className="h-11 rounded-lg border-[#dbe3ec] focus-visible:ring-[var(--np-secondary)]" autoFocus />
            </div>
            {error && <p data-testid="admin-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</p>}
            <button type="submit" data-testid="admin-submit-btn" disabled={busy} className="cta-btn w-full disabled:opacity-70">
              {busy ? <><Loader2 className="animate-spin" size={18} /> Verifica…</> : <>Accedi</>}
            </button>
            <p className="text-[12px] text-center pt-2" style={{ color: "var(--np-muted)" }}>La sessione scade automaticamente dopo 60 minuti di inattività.</p>
          </form>
        </div>
      </div>
    </div>
  );
}
